// The pronumbers the Pro drawer sits on while a record is being CREATED but has
// not been saved yet (#33471). Nothing is allocated until the user presses Save,
// so there is no real pronumber to show until then.
//
// Their own module because both ProDetailSlideOver and ProDetailContainer need
// them as VALUES, and the SlideOver already imports the Container — importing back
// the other way would be a runtime cycle (today's `import type` is fine only
// because types are erased).

export const CREATE_PRONUMBER_SENTINEL = 'NEW';

/**
 * The template twin. Deliberately "T"-prefixed: every template-aware branch in the
 * app — `isTemplatePronumber`, ProDetailContainer, InvoicingView, TracingView, and
 * the backend's `startswith("T")` — decides "is this a template" from the pronumber
 * itself, so a plain 'NEW' sentinel would make a template-in-progress read as an
 * ORDER (wrong field policy, wrong gates, wrong labels). 'TNEW' satisfies all of
 * them unchanged, front and back, without threading an isTemplate flag through
 * every layer.
 */
export const CREATE_TEMPLATE_PRONUMBER_SENTINEL = 'TNEW';

/**
 * True while the drawer holds no persisted record yet.
 *
 * This is the ONLY correct way to ask "are we still creating?". Testing for a
 * positive number instead works for orders (whose allocated pronumber is numeric)
 * but strands a template in create mode forever, because its allocated pronumber
 * is a "T…" STRING — which is what hid the History / Whse / Addl Cost tabs on a
 * template that had already been created.
 */
export const isCreateSentinel = (pro: number | string | null | undefined): boolean =>
  pro === CREATE_PRONUMBER_SENTINEL || pro === CREATE_TEMPLATE_PRONUMBER_SENTINEL;
